import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  collections = 'collections',
  collection = 'collection',
}

enum ExternalRoutesIds {
  metric = 'metric',
}

// root route
export const [collectionsRouteImplRef, collectionIndexRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.collections });

export const rootRouteRef = collectionsRouteImplRef;

// sub-routes within the plugin
export const [collectionRouteImplRef, collectionRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.collection,
    parent: rootRouteRef,
    path: '/:id',
  });

// external routes to other plugins
export const metricRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.metric,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  collections: collectionsRouteImplRef,
  collection: collectionRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  collections: collectionIndexRouteRef,
  collection: collectionRouteRef,
  metric: metricRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
